// /**
//  * Product - invontory
//  */

// React
import React, {useEffect} from 'react';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Store} from '../../../redux/reducers';
import {getProductsInventoryActions} from '../actions';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectProductsInventoryListByProductId,
  makeSelectError,
  makeSelectLoading,
  makeSelectCountList,
} from '../selectors';

// UI
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
} from '@material-ui/core';
// Type
import {
  SelectorPropsInventory,
  PropsInventory,
  PayloadInventory,
  ProductInventory,
} from '../interfaces';

type Data = ProductInventory;
type Props = {
  data: any;
};

type Ord = 'asc' | 'desc';
interface HeadCell {
  id: keyof Data;
  label: string;
}
interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Ord;
  orderBy: string;
  rowCount: number;
}

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      marginTop: theme.spacing(4),
      padding: theme.spacing(4),
      border: '1px solid #ddd',
      width: '100%',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      '& > *': {
        margin: theme.spacing(0, 1),
      },
    },
    table: {
      minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
  })
);
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
  a: {[key in Key]: number | string},
  b: {[key in Key]: number | string}
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

const headCells: HeadCell[] = [
  {id: 'id', label: 'شناسه انبار'},
  {
    id: 'name',
    label: 'نام انبار',
  },
  {
    id: 'current',
    label: 'موجودی فعلی',
  },
  {
    id: 'inbound',
    label: 'مجموع ورودی به انبار',
  },
  {
    id: 'outbound',
    label: 'مجموع خروجی از انبار',
  },
  {
    id: 'purchase',
    label: 'مجموع سفارش داده شده',
  },
];

function EnhancedTableHead(props: EnhancedTableProps) {
  const {order, orderBy, onRequestSort} = props;
  const createSortHandler = (property: keyof Data) => (
    event: React.MouseEvent<unknown>
  ) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            sortDirection={orderBy === headCell.id ? order : false}
            data-cy={headCell.id}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function Inventory(props: PropsInventory) {
  const classes = useStyles();
  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('id');
  const [dense] = React.useState(false);

  useEffect(() => {
    props.getProductsInventoryDispatch({id: props.data.id});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={props.productsInventoryList.length}
            />

            <TableBody>
              {stableSort(
                props.productsInventoryList,
                getComparator(order, orderBy)
              )
                .slice()
                .map((row: any, index: number) => {
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow key={index}>
                      <TableCell align="center">{row.id}</TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        align="center"
                      >
                        {row.name}
                      </TableCell>
                      <TableCell align="center">{row.current}</TableCell>
                      <TableCell align="center">{row.inbound}</TableCell>
                      <TableCell align="center">{row.outbound}</TableCell>
                      <TableCell align="center">{row.purchase}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorPropsInventory>(
  {
    productsInventoryList: makeSelectProductsInventoryListByProductId(),
    count: makeSelectCountList(),
    loading: makeSelectLoading(),
    error: makeSelectError(),
  }
);

function mapDispatchToProps(dispatch: Function) {
  return {
    getProductsInventoryDispatch: (payload: PayloadInventory) =>
      dispatch(getProductsInventoryActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Inventory);
